import { $http } from '../component-base/xhr';

export async function searchBank(params) {
    // const res = await $http.post('/rest/csc/v2/minor/tip/refund/tool/bank/list', {
    const res = await $http.post('/rest/csc/center/common/bank', {
        ...params,
    });
    return res.data.data;
}

export async function getBankBranch(params) {
    // const res = await $http.post('/rest/csc/v2/minor/tip/refund/tool/bank/branches', {
    const res = await $http.post('/rest/csc/center/common/bank/branch', {
        ...params,
    });
    return res.data.data;
}
export async function getToolProvince() {
    // const res = await $http.post('/rest/csc/v2/minor/tip/refund/tool/bank/province', {});
    const res = await $http.post('/rest/csc/center/common/bank/province', {});
    return res.data.data;
}

export async function getToolCity(params) {
    // const res = await $http.post('/rest/csc/v2/minor/tip/refund/tool/bank/city', {
    const res = await $http.post('/rest/csc/center/common/bank/city', {
        ...params,
    });
    return res.data.data;
}